export const IS_EMAIL_VERIFIED = 'is_email_verified';
export const FORCE_VERIFY_EMAIL = 'force_verify_email';

export const saveSignInVerifyEmailData = (isEmailVerified, forceVerifyEmail) => {
  localStorage.setItem(IS_EMAIL_VERIFIED, isEmailVerified);
  localStorage.setItem(FORCE_VERIFY_EMAIL, forceVerifyEmail);
};

export const removeSignInVerifyEmailData = () => {
  localStorage.removeItem(IS_EMAIL_VERIFIED);
  localStorage.removeItem(FORCE_VERIFY_EMAIL);
};
